export const Construction = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5 21L14.5084 11.2427C14.2009 10.4911 13.4694 10 12.6573 10H8.83095C8.28722 10 7.75371 10.1478 7.28746 10.4275L3 13V18L24.5 22" stroke="currentColor" stroke-width="2"/>
<path d="M29 29H19L29 17V29Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M8 30V10" stroke="currentColor" stroke-width="2"/>
<path d="M13 19.5L15 24V30" stroke="currentColor" stroke-width="2"/>
<circle cx="12.5" cy="4.5" r="2.5" stroke="currentColor" stroke-width="2"/>
</svg>`;
